import { render, staticRenderFns } from "./StandingHomeTable.vue?vue&type=template&id=b2c58c44&scoped=true&"
import script from "./StandingHomeTable.vue?vue&type=script&lang=js&"
export * from "./StandingHomeTable.vue?vue&type=script&lang=js&"
import style0 from "./StandingHomeTable.vue?vue&type=style&index=0&id=b2c58c44&prod&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2c58c44",
  null
  
)

export default component.exports